import { call, put, takeLatest } from 'redux-saga/effects';
import { VERIFY_HUBSPOT } from './constants';
import { verifyHubspot } from './actions';
import triggerNotification from 'utils/triggerNotification';
import { NOTIFICATION } from 'common/constants';
import request from 'utils/request';
import convertErrorMsg from 'utils/convertErrorMsg';
import { HUBSPOT_VERIFY } from 'common/strings';
import localStorageTemplates from 'common/local-storage-templates';
import { readToken } from 'utils/readToken';

export function* saveHubspotCode({ payload, metadata }) {
  const token = readToken();
  const { projectName } = metadata;
  try {
    const response = yield call(request, {
      method: 'post',
      endpoint: 'app/integration/hubspot',
      projectName,
      config: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          ...payload,
        },
      },
    });
    triggerNotification({
      title: HUBSPOT_VERIFY.ALERTS.INTEGRATE_HUBSPOT_SUCCESS,
      type: NOTIFICATION.TYPE.SUCCESS,
    });
    yield put(verifyHubspot.success());
  } catch (error) {
    const errorMessage = convertErrorMsg(error);

    triggerNotification({
      title: errorMessage,
      type: NOTIFICATION.TYPE.ERROR,
    });
    yield put(verifyHubspot.error(errorMessage));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export default function* hubspotVerify() {
  yield takeLatest(VERIFY_HUBSPOT.START, saveHubspotCode);
}
